import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn, FaYoutube, FaChalkboardTeacher, FaMapSigns } from 'react-icons/fa';
import { Helmet } from 'react-helmet';
import { FaRocket } from "react-icons/fa";
import homebackground from './../image/banner.png';

const StudentsNewGrads = ({ title }) => {

  return (
    <div className="w-full h-auto bg-white flex flex-col items-center justify-center lg:mt-20 sm:mt-0">
      <Helmet>
        <title>Students & New Grads- Nexify Infosystems</title>
        <meta name="description" content="Explore career opportunities for students and new grads at Nexify." />
        <meta name="keywords" content="students, new grads, careers, recruitment, job opportunities, Nexify, sales, training, career path" />
      </Helmet>
      <div
        className="w-full h-[440px] bg-cover bg-center relative flex items-center justify-center"
        style={{ backgroundImage: `url(${homebackground})` }}
      >
        {/* Black Overlay */}
        {/* <div className="absolute inset-0 bg-black opacity-50"></div> */}
        <div className="relative z-0 flex justify-center lg:justify-start items-center w-full px-4 sm:px-10 lg:px-20">
          <div
            className="opacity-0 translate-y-10 animate-slideUp bg-[#0c5495b3] p-6 shadow-lg text-white inline-block text-center lg:text-left max-w-[90%] sm:max-w-[80%] md:max-w-[60%] lg:max-w-[60%] lg:ml-14"
            style={{
              animation: "slideUp 1s ease-in-out forwards",
              animationDelay: "2s",
            }}
          >
            <h1 className="text-[8vw] md:text-[66px] font-semibold mb-2 break-words">
               Students & New Grads
            </h1>
            <h2 className="text-[5vw] md:text-[40px] text-[#efefef]">
            Opening doors, kick-starting careers, shaping success.
            </h2>
          </div>
        </div>
      </div>
      <div className="w-full max-w-[1320px] px-4 mx-auto mt-20 mb-5">

      <h2 className="mb-6 text-[#0e55a8] lg:text-[40px] text-[30px] lg:leading-[1.8] leading-[1.2] font-[700] text-left">
        Students & New Grads
      </h2>
      <div className="flex flex-col gap-6">
        <div className="bg-white flex flex-col md:flex-row items-center p-6 ">
          <div className="flex items-center justify-center w-20 h-20 bg-[#cce5ff] rounded-full mr-6">
            <FaRocket className="text-[#005eb8] text-5xl" />
          </div>
          <div className="flex-1">
            <h3 className="lg:text-[30px] text-[25px] leading-[1.25] text-[#363638] font-[700] mb-2">Kickstart Your Career</h3>
            <p className="text-[#6d6d70] font-[400] text-[16px] leading-[1.8]">
              While having previous sales experience is nice for a career at Nexify, it's not a requirement. The Sales Recruiter position is a great first step and we are ultimately looking for sales-minded people that we can help to train and develop.
            </p>
            <Link
              to="/recruiting"
              className="relative inline-flex items-center font-semibold text-[#005eb8] text-[15px] group mt-4"
            >
              <span className="mr-2 transition-transform group-hover:translate-x-1">&#10132;</span>
              <span className="relative after:absolute after:left-0 after:-bottom-1 after:w-0 after:h-[2px] after:bg-[#005eb8] after:transition-all after:duration-300 group-hover:after:w-full">
                5 Signs You're Perfect For Recruiting
              </span>
            </Link>
          </div>

        </div>
        <div className="bg-white flex flex-col md:flex-row items-center p-6 ">
          <div className="flex items-center justify-center w-20 h-20 bg-[#cce5ff] rounded-full mr-6">
            <FaChalkboardTeacher className="text-[#005eb8] text-5xl" />
          </div>
          <div className="flex-1">
            <h3 className="lg:text-[30px] text-[25px] leading-[1.25] text-[#363638] font-[700] mb-2">Training </h3>
            <p className="text-[#6d6d70] font-[400] text-[16px] leading-[1.8]">
              New employees at Nexify will go through an extensive training program to immediately expose them to recruiting best practices and office dynamics: shadowing activities, conference calls, webinars, role plays, Nexify Talent University courses, and more. Each new hire has the support, experience, and expertise of their entire office at their fingertips.
            </p>
            <Link
              to="/typical-recruiter"
              className="relative inline-flex items-center font-semibold text-[#005eb8] text-[15px] mt-4 group"
            >
              <span className="mr-2 transition-transform group-hover:translate-x-1">&#10132;</span>
              <span className="relative after:absolute after:left-0 after:-bottom-1 after:w-0 after:h-[2px] after:bg-[#005eb8] after:transition-all after:duration-300 group-hover:after:w-full">
                A Typical Day as a Recruiter
              </span>
            </Link>
          </div>
        </div>
        <div className="bg-white flex flex-col md:flex-row items-center p-6 ">
          <div className="flex items-center justify-center w-20 h-20 bg-[#cce5ff] rounded-full mr-6">
            <FaMapSigns className="text-[#005eb8] text-5xl" />
          </div>
          <div className="flex-1">
            <h3 className="lg:text-[30px] text-[25px] leading-[1.25] text-[#363638] font-[700] mb-2">Career Path </h3>
            <p className="text-[#6d6d70] font-[400] text-[16px] leading-[1.8]">
              Recruiters who are interested in pursuing a career in sales can quickly move into the Account Manager role. First, you'll learn the elements of the Recruiter role and then progress onto learning our sales cycle. This is an individual process so the completion time can vary between 3-6 months. Nexify’s intention is to keep Recruiters on the fast track to sales and promote as soon as possible.
            </p>
            <Link
              to="/sciencesales"
              className="relative inline-flex items-center font-semibold text-[#005eb8] text-[15px] mt-4 group"
            >
              <span className="mr-2 transition-transform group-hover:translate-x-1">&#10132;</span>
              <span className="relative after:absolute after:left-0 after:-bottom-1 after:w-0 after:h-[2px] after:bg-[#005eb8] after:transition-all after:duration-300 group-hover:after:w-full">
                The Science of Sales
              </span>
            </Link>
          </div>
        </div>
      </div>

      <div className="bg-white flex flex-col md:flex-row lg:p-12 p-6 w-full max-w-[1320px] lg:text-center md:shadow-lg md:rounded-lg gap-20 lg:mb-10 lg:mt-10 justify-center items-center">
        {/* Left Side */}
        <div className="lg:mb-2 md:mb-0 lg:text-center">
          <h3 className="lg:text-3xl text-xl font-[500] text-black lg:mt-2">Follow us for updates at #NexifyCareers</h3>
        </div>

        {/* Social Media Icons */}
        <div className="flex lg:justify-center lg:items-center lg:gap-6 gap-3 lg:mt-4 mt-[-10px] md:mt-0 ">

          <a
            href="https://www.linkedin.com/company/nexify-infosystems-llc"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center w-14 h-14 rounded-md bg-[#005eb8] text-white text-2xl"
          >
            <FaLinkedinIn />
          </a>
          <a
            href="https://www.instagram.com/nexify_infosystems?igsh=MXZkN3loYWtiYmVpdw=="
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center w-14 h-14 rounded-md bg-[#005eb8] text-white text-2xl"
          >
            <FaInstagram />
          </a>
        </div>
      </div>
      </div>
    </div>
  );
};

export default StudentsNewGrads;
